package com.routexk.quiz.ui.theme

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import org.jetbrains.compose.web.css.cssRem
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase
import kotlinx.browser.document
import org.jetbrains.compose.web.css.px

fun initAppTheme(ctx: InitSilkContext) {

    val fontFaceStyle = document.createElement("style") as org.w3c.dom.HTMLStyleElement
    fontFaceStyle.id = "custom-fonts-face"
    fontFaceStyle.textContent = """

        @font-face {
            font-family: 'GalakRound';
            src: url('/fonts/GalakRound-GalakProRegular.woff2') format('woff2');
            font-weight: 400;
            font-style: normal;
            font-display: swap;
        }
        @font-face {
            font-family: 'GalakRound';
            src: url('/fonts/GalakRound-Medium.woff2') format('woff2');
            font-weight: 500;
            font-style: normal;
            font-display: swap;
        }

        @font-face {
            font-family: 'Gilroy';
            src: url('/fonts/Gilroy-Regular.woff2') format('woff2');
            font-weight: 400;
            font-style: normal;
            font-display: swap;
        }
        @font-face {
            font-family: 'Gilroy';
            src: url('/fonts/Gilroy-Medium.woff2') format('woff2');
            font-weight: 500;
            font-style: normal;
            font-display: swap;
        }

        @font-face {
            font-family: 'Sansation';
            src: url('/fonts/SansationRegular.woff2') format('woff2');
            font-weight: 400;
            font-style: normal;
            font-display: swap;
        }

        @font-face {
            font-family: 'Montserrat';
            src: url('/fonts/Montserrat-Bold.woff2') format('woff2');
            font-weight: 700;
            font-style: normal;
            font-display: swap;
        }
    """.trimIndent()
    document.head?.appendChild(fontFaceStyle)

    // Fluid root font-size: everything sized in rem (see Int.rpx). Mobile keeps
    // the design's 1:1 sizes (scroll is fine there); from tablet up the UI
    // scales with the viewport — 16px at the 1280x700 design frame, up to 20px
    // on large desktops. vmin keeps short-but-wide laptops compact so bottom
    // CTAs get breathing room instead of hugging the viewport edge.
    val rootScaleStyle = document.createElement("style") as org.w3c.dom.HTMLStyleElement
    rootScaleStyle.id = "fluid-root-font-size"
    rootScaleStyle.textContent = """
        html { font-size: 16px; }
        @keyframes funnel-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        @keyframes funnel-marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        @keyframes funnel-marquee-y { from { transform: translateY(0); } to { transform: translateY(-50%); } }
        @media (min-width: 768px) {
            /* Scale with the tightest constraint: overall size (vmin), the
               ~1190rpx-wide hero row (1.3vw) and the ~650rpx-tall first
               screen (2.4vh) — so content shrinks to fit instead of
               overflowing into scroll on small or short windows. */
            html { font-size: clamp(10px, min(calc(7px + 1.25vmin), 1.3vw, 2.4vh), 20px); }
        }
    """.trimIndent()
    document.head?.appendChild(rootScaleStyle)

    ctx.stylesheet.registerStyleBase("body") {
        Modifier
            .fontFamily(AppTypography.PRIMARY_FONT_NAME, AppTypography.PRIMARY_FONT_FALLBACK)
            .fontSize(1.cssRem)
            .fontWeight(AppTypography.Regular)
            .margin(0.px)
            .padding(0.px)
    }
}
